import { z } from 'zod';
export const PublicSettingsSchema = z.object({
    data: z
        .object({
        aides: z
            .object({
            hideDemandeDepotPieces: z.boolean().optional(),
        })
            .optional(),
        dashboard: z
            .object({
            createDemande: z.boolean().optional(),
        })
            .optional(),
    })
        .optional(),
    headers: z.object({
        'x-tz': z.string().optional(),
    }),
});
const FormattedPublicSettingsSchema = z.object({
    timeZone: z.string(),
    hideDemandeDepotPieces: z.boolean(),
    createDemande: z.boolean(),
});
export const GestionDepotDemandePublicSettingsSchema = z.object({
    autoRattachementByAdministrator: z.object({
        value: z.boolean(),
    }),
});
//# sourceMappingURL=public-settings.js.map